import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useLocation } from "react-router-dom"
import { showModal } from "../../features/modal/modalSlice"
import { useScrollLock } from "../../hooks/useScrollLock"
import styled from "styled-components"
import PageTopTitle from "../shared/PageTopTitle"
import Button from "../shared/Button"
import SmallSpinner from "../shared/spinners/SmallSpinner"


const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 1000px;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border: 1px solid;
        border-color: ${({ theme }) => theme.mainBorderColor};
        padding-top: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .content{
            margin: 40px;
            padding: 30px;
            width: auto;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            width: 700px;

            p{
                font-size: var(--font-size-md);
                font-weight: var(--font-weight-lg);
                background-color: ${({ theme }) => theme.secondaryBgColor};
                padding: 20px 15px;
                border-radius: 20px;
                margin-bottom: 20px;
            }

            div{
                font-size: var(--font-size-md);
                font-weight: var(--font-weight-lg);
                padding: 10px;
                margin-bottom: 10px;
                border-radius: 20px;

                a{
                    color: #BB2649;
                    padding: 5px;
                    background-color: rgba(187, 38, 73, 0.2);
                    border-radius: 10px;
                }
            }

        }

        .button-grp{
            width: 100%;
            display: flex;
            justify-content: center;
            margin-top: auto;
            margin: 30px 0;
        }
    }
`
const ResultErrAracMuayeneModal = () => {

    const {resultModalData, modalLocation} = useSelector(state => state.modal)
    const dispatch = useDispatch()
    const location = useLocation()
    const { lockScroll, unlockScroll } = useScrollLock();
    

         //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])

    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])


    if(!resultModalData){
        return null
    }

    //! belki burada api den gelen olumlu ya da olumsuz cevaba göre farklı components lar render edilebilir.( belki bu sayede şu gıcık svg renk değiştirme sorunu çözülür.) ***********************************************************
    
  return (
    <ModalContainer onClick={()=> dispatch(showModal(null))}>
    <div className="modal" onClick={(e) => e.stopPropagation()}>
        <PageTopTitle title={"Toplu Araç Ekle"}/>
        <div className="content">
        <p>{resultModalData.msg.plaka} plakalı aracın Fenni Muayene bilgisi bulunamadı! Bunun olası sebepleri;</p>
        <div>Araç herhangi bir yetki belgesinde kayıtlı değil ise buradan sorgulanmamaktadır.</div>
        <div>Yetki belgesinde kayıtlı olmasına rağmen fenni muayene bilgisi bulunamadıysa, muayene süresi geçmiş demektir.</div>
        <div>Araç herhangi bir yetki belgesinde kayıtlı değil ise buradan sorgulanmamaktadır.</div>
        <div>Fenni Muayene bilgisini <a href="https://www.tuvturk.com.tr/plaka-sorgulama.aspx" target="blank">Tüvtürk</a> Adresinden sorgulayabilirsiniz.</div>
        </div>
        <div className='button-grp'>
        <Button color={"#F4F4F4"} background={"var(--color-main)"} width="220px" radius={"10px"} text={"Geri Dön"} padding="0 10px" handleClick={()=> dispatch(showModal(null))}/>
    </div>
    </div>
</ModalContainer>
  )
}

export default ResultErrAracMuayeneModal